const STORAGE_TOKEN = 'parent_token'
const STORAGE_STUDENT = 'parent_active_student_id'
const COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60

function safeLocalStorageGet(key) {
  try {
    return localStorage.getItem(key) || ''
  } catch (e) {
    return ''
  }
}

function safeLocalStorageSet(key, value) {
  try {
    localStorage.setItem(key, value)
  } catch (e) {
    // Cookie fallback below keeps the parent session usable in restricted WebViews.
  }
}

function safeLocalStorageRemove(key) {
  try {
    localStorage.removeItem(key)
  } catch (e) {
    // ignore storage failures in mobile WebViews
  }
}

function getCookie(name) {
  const prefix = `${name}=`
  return document.cookie
    .split(';')
    .map(part => part.trim())
    .find(part => part.startsWith(prefix))
    ?.slice(prefix.length) || ''
}

function setCookie(name, value, maxAge = COOKIE_MAX_AGE_SECONDS) {
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAge}; path=/; samesite=lax`
}

function removeCookie(name) {
  document.cookie = `${name}=; max-age=0; path=/; samesite=lax`
}

export function getParentToken() {
  const token = safeLocalStorageGet(STORAGE_TOKEN) || decodeURIComponent(getCookie(STORAGE_TOKEN) || '')
  if (token && !safeLocalStorageGet(STORAGE_TOKEN)) {
    safeLocalStorageSet(STORAGE_TOKEN, token)
  }
  return token
}

export function setParentToken(token) {
  if (!token) {
    clearParentToken()
    return
  }
  safeLocalStorageSet(STORAGE_TOKEN, token)
  setCookie(STORAGE_TOKEN, token)
}

export function clearParentToken() {
  safeLocalStorageRemove(STORAGE_TOKEN)
  removeCookie(STORAGE_TOKEN)
}

export function getParentActiveStudentId() {
  return safeLocalStorageGet(STORAGE_STUDENT)
}

export function setParentActiveStudentId(id) {
  if (id) {
    safeLocalStorageSet(STORAGE_STUDENT, id)
  } else {
    safeLocalStorageRemove(STORAGE_STUDENT)
  }
}

export function clearParentSession() {
  clearParentToken()
  safeLocalStorageRemove(STORAGE_STUDENT)
}
